import React from 'react';
import { Field, FieldLabel, FieldDescription } from '@/components/ui/field';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

export default function StepDeadline({ formik, onNext, onBack }) {
  const handleNext = async e => {
    e.preventDefault();
    await formik.setTouched({ starts_at: true, ends_at: true });
    const errors = await formik.validateForm();
    if (errors.starts_at || errors.ends_at) return;
    onNext();
  };

  return (
    <div className="page page--wrap">
      <div className="page__col">
        <form
          className="form form--step-by-step"
          method="post"
          onSubmit={handleNext}
        >
          <div className="page__content mb-12 animate-fade-in">
            <div className="new-questions__header">
              <h2 className="new-questions__title">Período de inscrição</h2>
            </div>

            <div className="flex animate-fade-in flex-col gap-6">
              <Field>
                <FieldLabel htmlFor="starts_at">* Início das inscrições</FieldLabel>
                <Input
                  id="starts_at"
                  name="starts_at"
                  type="datetime-local"
                  value={formik.values.starts_at}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  aria-invalid={Boolean(formik.touched.starts_at && formik.errors.starts_at)}
                />
                {formik.touched.starts_at && formik.errors.starts_at && <FieldDescription className="text-danger">{formik.errors.starts_at}</FieldDescription>}
              </Field>

              <Field>
                <FieldLabel htmlFor="ends_at">* Fim das inscrições</FieldLabel>
                <Input
                  id="ends_at"
                  name="ends_at"
                  type="datetime-local"
                  value={formik.values.ends_at}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  aria-invalid={Boolean(formik.touched.ends_at && formik.errors.ends_at)}
                />
                {formik.touched.ends_at && formik.errors.ends_at && <FieldDescription className="text-danger">{formik.errors.ends_at}</FieldDescription>}
              </Field>
            </div>
          </div>

          <div className="flex gap-3">
            <Button
              type="button"
              variant="outline"
              size="md"
              wide
              onClick={onBack}
            >
              Voltar
            </Button>
            <Button
              type="submit"
              variant="default"
              size="md"
              wide
            >
              Próximo
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
